import React, { useState } from 'react';
import * as translator from "../../utils/translator";
import "./OTCProductRow.css";
import Information from "../../icons/Information.svg";
import InformationGreen from "../../icons/Information-Green.svg";
import QuantityControl from '../QuantityControl/QuantityControl';
import { clientConfig } from '../../config';
import { useParams } from 'react-router-dom';

type OTCProductRowProps = {
    productItem: ProductItem
    countryId: string
    currencySign: string //countryCurrencySign ($)
    currencyRate: number // the rate in the currency of the country (for example in German & Swiss changes)
    OTCAddonsAttributes?: OTCAddonsAttributes | null //The whole OTC addons logic from useOTCaddons
    showBin?: boolean
    quantityProp?: number // can also get it from OTCAddonsAttributes, but some pages like payment shouldn't have The whole logic of OTCAddonsAttributes
    shouldShowQuantityControl?: boolean
}

const OTCProductRow: React.FC<OTCProductRowProps> = ({ 
    productItem,
    countryId,
    currencySign,
    currencyRate,
    OTCAddonsAttributes,
    quantityProp,
    shouldShowQuantityControl = true,
 }) => {
    const { language } = useParams()

    const [isInformationEnabled, setIsInformationEnabled] = useState<boolean>(false);
    const quantity = quantityProp || OTCAddonsAttributes?.ProductAndQuantityById[productItem.id]?.quantity;

    return (
        <div className='otc-addons-row-container'>
            <div key={productItem.id} className='otc-addons-row'>

                <div className='otc-product-image-and-details'>
                    <img className='otc-product-image' src={clientConfig.IMAGES_URL + productItem.imgSrc} alt="product-item" />
                    <div className='otc-product-item-details'>
                        <p className='product-item-details-title'>{productItem.title}</p>
                        {/* TODO:Translations */}

                        {
                            productItem.custom_quantity_title ?
                                <p className='product-item-details-quantity'>{translator.translate(language, "shipping", "otcCartPopup/package")}: {productItem.custom_quantity_title}</p>
                                :
                                null
                        }

                        {
                            quantity ?
                                <p className='product-item-details-quantity'>{translator.translate(language, "default", "OrderWindow/quantity")}: {quantity}</p>
                                :
                                null
                        }

                        <p className='product-item-details-price'>
                            {`${(quantity ? (productItem.price * currencyRate * quantity) : (productItem.price * currencyRate)).toFixed(2)} ${currencySign}`} <span className='product-item-details-price-discount'> 25% OFF</span>
                        </p>

                        <p className='product-item-details-price-deleted'>
                            {`${(quantity ? (productItem.price * currencyRate * quantity) / 0.75 : (productItem.price * currencyRate) / 0.75).toFixed(2)} ${currencySign}`}
                        </p>
                    </div>
                </div>


                {/* Show the quantityControl only if we have OTCAddonsAttributes */}
                {
                    OTCAddonsAttributes ?

                        <div className='quantity-control-wrapper'>
                            <button onClick={() => setIsInformationEnabled((current: boolean) => !current)} className={`product-information-button${isInformationEnabled ? "-enabled" : ""}`}>
                                <img src={isInformationEnabled ? Information : InformationGreen} alt="i" />
                            </button>

                            {
                                shouldShowQuantityControl ?
                                    <QuantityControl
                                        idPrefix={`otc-product-row-${productItem.id}-quantity-control`}
                                        decrementButtonOnClick={() => OTCAddonsAttributes.decrementQuantity(productItem.id)}
                                        quantity={quantity!}
                                        incrementButtonOnClick={() => OTCAddonsAttributes.incrementQuantity(productItem.id)}
                                    />
                                    :
                                    null
                            }

                                </div>

                        :

                        null
                }

            </div>

            {/* Product's Information text */}
            {
                isInformationEnabled ?
                    <div className='information-text-container'>
                        <p className='information-text'>
                            {productItem.description}
                        </p>
                    </div>
                    :
                    null
            }

        </div>

    )
}

export default OTCProductRow